import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { CommonContext } from '../../component/common/context/commonContext'
import { getContentSize } from '../../utils/screenUtils'
import { useMountEffect } from 'primereact/hooks'
import PdaTitle from '../../component/common/PdaTitle'
import { InputText } from 'primereact/inputtext'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const PiecePicking = () => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const scanRef = useRef<HTMLInputElement>(null)
    const [lgstNo, setLgstNo] = useState<string>('')
    const [height, setHieght] = useState<number>(getContentSize())
    const [params, setParams] = useState<PiecePickingSearch>({
        lgstNo: '',
    })

    useMountEffect(() => {
        setTimeout(() => {
            if (scanRef && scanRef.current) {
                scanRef.current.focus()
                scanRef.current.select()
                setHieght(getContentSize())
            }
        }, 300)
    })

    const findMidmileIncoming = useCallback(
        async (params: PiecePickingSearch) => {
            const { outbId, pickingResult, goodsNm, goodsQty, cancelQty, specTxt, gdslsUnitCd } = await $http().get('/outbound/piece-picking', {
                params: { ...params },
            })

            navigate('/outbound/piece-picking/status', { state: { outbId, pickingResult, goodsNm, goodsQty, cancelQty, specTxt, gdslsUnitCd } })
            // if (pickingResult) {
            //
            // } else {
            //     navigate('/outbound/piece-picking/status', { state: { outbId, pickingResult, goodsNm, goodsQty, cancelQty, specTxt, gdslsUnitCd } })
            // }
        },
        [$http, $toast, navigate, lgstNo],
    )

    useEffect(() => {
        if (params.lgstNo) {
            findMidmileIncoming(params)
        }
    }, [params, findMidmileIncoming])

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            setParams({
                ...params,
                lgstNo,
            })
        }
    }

    const onChangeLgstNo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setParams({
            ...params,
            lgstNo: '',
        })
        setLgstNo(e.currentTarget.value)
    }

    return (
        <>
            <PdaTitle title={t(tokens.common.individual_picking)} historyBack goToHome />
            <div className="grid pda-search p-3">
                <div className="col-12 flex">
                    <InputText
                        ref={scanRef}
                        value={lgstNo}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.common.please_scan_product_label_barcode)}
                        onChange={(e) => onChangeLgstNo(e)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                        inputMode="none"
                        autoFocus={true}
                    />
                </div>
            </div>
            <div className="grid pl-2">
                <div className="font-bold text-center w-full vertical-align-middle" style={{ paddingTop: height / 3 }}>
                    {t(tokens.common.please_scan_product_label_barcode)}
                </div>
            </div>
        </>
    )
}

export default PiecePicking
